import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconStreamCircle = (props) => {
  props = Object.assign({viewBox: '0 0 32 32'}, props);
  return (
    <SvgIcon {...props}>
        <path d='M12.333 22.467l11.133-6.467-11.133-6.467v12.933zM20 16.067l-6 3.467v-6.933l6 3.467z'/>
        <path d='M16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM30.267 16c0 7.867-6.4 14.267-14.267 14.267s-14.267-6.4-14.267-14.267c0-7.867 6.4-14.267 14.267-14.267s14.267 6.4 14.267 14.267z'/>
    </SvgIcon>
  );
};

IconStreamCircle.displayName = 'IconStreamCircle';
IconStreamCircle.muiName = 'SvgIcon';

export default IconStreamCircle;



// WEBPACK FOOTER //
// ./src/components/Icons/IconStreamCircle.js